import { getApiBaseUrl, getApiKey } from 'fake-db/apiConfig'
import Mock from '../mock'
import axios from 'axios.js'

Mock.onPost(/^\/api\/fiscal\/[a-z-]+$/).reply(async (config) => {
    const action = config.url.split('/').pop()
    const token = localStorage.getItem('accessToken')
    try {
        const response = await axios.post(
            `${getApiBaseUrl().replace(/\/+$/, '')}/fiscal/dispatch/?apiKey=${encodeURIComponent(getApiKey())}&action=${encodeURIComponent(action)}`,
            JSON.parse(config.data || '{}'),
            { headers: token ? { Authorization: `Bearer ${token}` } : {}, timeout: 20000 }
        )
        if (!response.data || typeof response.data !== 'object') {
            // No full payload: it may contain a token, payment contact or DataMatrix.
            console.error('Фискальный API: сервер вернул ответ не в формате JSON', { action, status: response.status })
            return [502, { errorInfo: 'Сервер вернул некорректный ответ фискального модуля' }]
        }
        return [response.status, response.data]
    } catch (error) {
        const data = error?.response?.data
        return [error?.response?.status || 502, data && typeof data === 'object' ? data : { errorInfo: 'Нет связи с фискальным модулем' }]
    }
})
